import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from "clsx";
import Image from "../../../utils/image";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "block"
	},
	logo: {
		alignItems: "center",
		background: "#FFFFFF",
		boxSizing: "content-box",
		display: "flex",
		height: 44,
		padding: theme.spacing(2, 3),
		width: 100,
		[theme.breakpoints.up("md")]: {
			height: 80,
			padding: theme.spacing(3, 4),
			width: 180
		}
	}
}));

const Logo = () => {
	const css = useStyles();
	return (
		<div className={clsx("logo", css.root)}>
			<a className={css.logo} href="/">
				<Image
					filename="/img/altenwohnheim-kufstein.svg"
					alt="Altenwohnheim Kufstein"
					loading="eager"
					height="78"
					width="180"
					disableCover
				/>
			</a>
		</div>
	);
};

export default Logo;
